import {
    createUnknownComponentVNode as _$cc,
} from 'intact';
import {Sender} from 'kpc';


export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$cc(Sender, {
        'generating': this.get('generating'),
        'inputDisabled': this.get('generating'),
        'buttonTooltip': {send: '发送消息', stop: '停止生成'},
        'ev-messageSend': this.onMessageSend,
        'ev-stopGenerate': this.onStopGenerate,
        'ev-$model:value': function($v) {
            $this.set('value', $v);
        },
        'value': $this.get('value')
    });
};